import { InjectionToken } from '@angular/core';

export const FACEBOOK_PIXEL_SETTINGS_TOKEN = new InjectionToken('facebook-pixel-settings', {
    factory: () => ({ pixelID: '', isEnabled: true })
});
